import { render, staticRenderFns } from "./JcdcFileInput.vue?vue&type=template&id=5a4df167"
import script from "./JcdcFileInput.vue?vue&type=script&lang=ts"
export * from "./JcdcFileInput.vue?vue&type=script&lang=ts"
import style0 from "./JcdcFileInput.vue?vue&type=style&index=0&id=5a4df167&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports